/* eslint-disable */
const STORE_STATE = {INITIALIZED: 0, CLEAR: 1, UNSAVED: 2}

export default {
  created: function () {
  },
  methods: {
    isInitState(state) {
      return state == STORE_STATE.INITIALIZED;
    },
    isClearState(state) {
      return state == STORE_STATE.CLEAR;
    },
    isUnsavedState(state) {
      return state == STORE_STATE.UNSAVED;
    },
    getInitState() {
      return STORE_STATE.INITIALIZED;
    },
    getUnsavedState() {
      return STORE_STATE.UNSAVED;
    },
    getSavedState() {
      return STORE_STATE.CLEAR;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/StorageState.js